/**
 * "Not now" for the Setup help guide.
 *
 * The guide auto-starts on a new organizer's first visit to Setup and walks tab to tab. That is
 * right when they wandered in to look round, and wrong when something SENT them to one specific
 * tab to do one specific thing — the Event Pass offer's "See who still needs to register" sends
 * them to Setup → Players, and the guide dragged them off to Basic before they saw a single
 * player. Whoever sends the organizer somewhere on purpose calls suppressSetupTourOnce() first.
 *
 * The guide is only postponed: its own pending / quiz-arrival signals are left untouched, so it
 * still introduces itself on a later Setup visit. sessionStorage, because the hand-over is a full
 * page load. Dependency-free so the quiz can use it without pulling in the tour library.
 */
export const SETUP_TOUR_SUPPRESS_KEY = 'sp_setup_tour_suppress';

export function suppressSetupTourOnce(): void {
    try { sessionStorage.setItem(SETUP_TOUR_SUPPRESS_KEY, '1'); } catch { /* private mode */ }
}

/** True once per suppression: reads the flag and clears it. */
export function consumeSetupTourSuppression(): boolean {
    try {
        const on = sessionStorage.getItem(SETUP_TOUR_SUPPRESS_KEY) === '1';
        sessionStorage.removeItem(SETUP_TOUR_SUPPRESS_KEY);
        return on;
    } catch {
        return false;
    }
}
